import { Grid } from '@material-ui/core';
import { FormikActions, getIn } from 'formik';
import * as _ from 'lodash';
import { inject } from 'mobx-react';
import * as React from 'react';
import ESDialog from 'src/common/ESDialog';
import FullWidthField from 'src/common/FullWidthField';
import SelectField from 'src/common/SelectField/SelectField';
import { IKpi, IKpiType } from 'src/Definitions';
import { IdentifierEntityDto } from 'src/generated_client';
import { IStores } from 'src/Stores';
import * as Yup from 'yup';

interface IKpiFormValues {
    name: string;
    shortName: string;
    description: string;
    lowerLimit: number;
    upperLimit: number;
    kpiTypeId: string;
}

const KpiSchema = Yup.object().shape({
    description: Yup.string(),
    lowerLimit: Yup.number(),
    name: Yup.string(),
    shortName: Yup.string(),
    upperLimit: Yup.number(),
});

interface IKpiDialogProps {
    close?: () => void;
    isLoading?: boolean;
    isOpen?: boolean;
    kpi?: IKpi;
    saveKpi?: (kpi: IKpi) => Promise<void>;
    kpiTypes?: IKpiType[];
    getKpiTypes?: () => void;
}

class KpiDialog extends React.Component<IKpiDialogProps> {
    public save = (values: IKpiFormValues, formikBag: FormikActions<IKpiFormValues>) => {
        this.props.kpi!.name = values.name;
        this.props.kpi!.shortName = values.shortName;
        this.props.kpi!.description = values.description;
        this.props.kpi!.lowerLimit = values.lowerLimit;
        this.props.kpi!.upperLimit = values.upperLimit;
        const kpiType = _.find(this.props.kpiTypes, { id: values.kpiTypeId });
        if (kpiType) {
            this.props.kpi!.kpiType = new IdentifierEntityDto();
            this.props.kpi!.kpiType.id = values.kpiTypeId;
            this.props.kpi!.kpiType.name = kpiType.name;
        }
        this.props.saveKpi!(this.props.kpi!).finally(() => formikBag.setSubmitting(false));
    };

    public componentDidMount() {
        this.props.getKpiTypes!();
    }

    public getKpiTypeName(kpiType: IKpiType) {
        return kpiType.name;
    }

    public getKpiTypeValue(kpiType: IKpiType) {
        return kpiType.id;
    }

    public getKpiTypeId() {
        if (this.props.kpi && this.props.kpi.kpiType) {
            return this.props.kpi.kpiType.id || '';
        } else {
            return '';
        }
    }

    public render() {
        const { close, isLoading, isOpen, kpi, kpiTypes } = this.props;
        const initialValues = { ...kpi, kpiTypeId: this.getKpiTypeId() } as IKpiFormValues;

        const hasValue = (field: string, values: IKpiFormValues) => {
            const value = getIn(values, field);

            return !!value;
        };

        return (
            <ESDialog
                close={close!}
                initialValues={initialValues}
                isLoading={isLoading}
                open={isOpen!}
                save={this.save}
                title={kpi!.isNew ? 'Create Kpi' : 'Edit Kpi'}
                validationSchema={KpiSchema}
            >
                {({ values }) => (
                    <Grid container spacing={24}>
                        <Grid item xs={12} sm={6}>
                            <FullWidthField autoFocus name="name" label="Name" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FullWidthField name="shortName" label="Short Name" />
                        </Grid>
                        <Grid item xs={12}>
                            <FullWidthField name="description" label="Description" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FullWidthField name="lowerLimit" label="Lower Limit" type="number" />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FullWidthField name="upperLimit" label="Upper Limit" type="number" />
                        </Grid>
                        <Grid item xs={12}>
                            <SelectField
                                fullWidth
                                label="Kpi Type"
                                inputId="kpiTypeId"
                                data-cy="kpiTypeId"
                                name="kpiTypeId"
                                items={kpiTypes}
                                getName={this.getKpiTypeName}
                                getValue={this.getKpiTypeValue}
                                shrinkLabel={hasValue('kpiTypeId', values)}
                            />
                        </Grid>
                    </Grid>
                )}
            </ESDialog>
        );
    }
}

const InjectedKpiDialog = inject<IStores, IKpiDialogProps, Partial<IKpiDialogProps>, any>(
    (stores: IStores) => ({
        close: stores.kpis.closeDialog,
        getKpiTypes: stores.kpiTypes.getAllKpiTypes,
        isLoading: stores.kpis.isLoading,
        isOpen: stores.kpis.isModalOpen,
        kpi: stores.kpis.selectedKpi,
        kpiTypes: stores.kpiTypes.kpiTypes,
        saveKpi: stores.kpis.saveKpi,
    })
)(KpiDialog);

export default InjectedKpiDialog;



// WEBPACK FOOTER //
// ./src/kpis/KpiDialog.tsx